import { Injectable } from '@angular/core';
import { PartnersConstants } from '../Partners_api/constants/partners.constants';
import { map } from 'rxjs/internal/operators/map';
import { HttpMethodsService } from '../_helpers/http-methods.service';
import { rejectAndApprove } from '../../../../../app/modules/partner-content/Review-partner-content/Interface/review-partner.i';
import { OemConstants } from '../oem/constants/oem.constants';

@Injectable({
  providedIn: 'root'
})
export class PartnersService {
  userId = sessionStorage.getItem('userId');
  PARTNER_URL = PartnersConstants.PARTNER + PartnersConstants.PARTNER + PartnersConstants.PARTNERS;
  PARTNER_ID_URL = PartnersConstants.PARTNER + PartnersConstants.PARTNER + PartnersConstants.SLASH;
  PARTNER_SEARCH = PartnersConstants.PARTNER + PartnersConstants.PARTNER + PartnersConstants.PARTNERS + PartnersConstants.SEARCH_NAME;
  postPartnerUrl = PartnersConstants.PARTNER + PartnersConstants.PARTNER + PartnersConstants.USERS + PartnersConstants.SLASH +
    this.userId + PartnersConstants.PARTNERS;
  putImageUrl = PartnersConstants.USERS + PartnersConstants.SLASH + this.userId +
    PartnersConstants.PARTNERS + PartnersConstants.SLASH;
  newPutImageUrl = PartnersConstants.PARTNERS + PartnersConstants.SLASH;
  previous_message_url = PartnersConstants.PARTNER + PartnersConstants.PARTNER + PartnersConstants.PREVIOUS_MESSAGE;
  constructor(private httpMethod: HttpMethodsService) { }

  getAllPartners(sortby: string, sorttype: string) {
    const url = this.PARTNER_URL + PartnersConstants.SORTBY + sortby + PartnersConstants.SORT_TYPE + sorttype;

    return this.httpMethod.get(url)
      .pipe(map((res: any) =>
        res));
  }

  getPartnerById(partnerId: string) {
    const url = this.PARTNER_ID_URL + partnerId;

    return this.httpMethod.get(url)
      .pipe(map((res: any) =>
        res));
  }

  getAllPartnersBySearch(name: string) {
    const url = this.PARTNER_SEARCH + name;

    return this.httpMethod.get(url)
      .pipe(map((res: any) =>
        res));
  }

  getAllPartnersInfoSortBy(sortby, sorttype) {
    const url = this.PARTNER_URL + PartnersConstants.SORTBY + sortby + PartnersConstants.SORT_TYPE + sorttype;

    return this.httpMethod.get(url)
      .pipe(map((res: any) =>
        res));
  }

  createPartner(configurationsJson: string) {
    const url = this.postPartnerUrl;

    return this.httpMethod.post(url, configurationsJson)
      .pipe(map((res: any) =>
        res));
  }

  putPartnerById(configurationsJson: string, id: string) {
    const url = this.postPartnerUrl + PartnersConstants.SLASH + id;

    return this.httpMethod.patch(url, configurationsJson)
      .pipe(map((res: any) =>
        res));
  }

  putImage(image: File, imageType: string, partnerId: string, imageUploadedBy: string) {
    const url = (imageUploadedBy == '') ? this.putImageUrl + partnerId : 
    PartnersConstants.USERS + PartnersConstants.SLASH + imageUploadedBy +
    PartnersConstants.PARTNERS + PartnersConstants.SLASH + partnerId;

    return this.httpMethod.putImage(url, image, imageType, true)
      .pipe(map((res: any) =>
        res));
  }

  getPartnerByImage(partnerId: string) {
    const url = this.putImageUrl + partnerId;

    return this.httpMethod.getImage(url, true)
      .pipe(map((res: any) =>
        res));
  }

  sendRejectAndApprove(autoId, contentId, action, comment: rejectAndApprove) {
    // const url = `/modelsku/modelskus/${autoId}/contents/${contentId}/${action}`;
    const url = OemConstants.SKU_COMMON + OemConstants.SLASH_MODELSKUS + OemConstants.SLASH + autoId + OemConstants.SLASH + OemConstants.CONTENTS + OemConstants.SLASH + contentId + OemConstants.SLASH + action;

    return this.httpMethod.patch(url, comment)
      .pipe(map((res: any) =>
        res));
  }

  sendApproveAndPush(comment, action: boolean) {
    const url = OemConstants.SKU_COMMON + OemConstants.SLASH_MODELSKUS + OemConstants.SLASH + OemConstants.APPROVED_STATUS + OemConstants.SLASH + OemConstants.PUSH + OemConstants.QUESTION + OemConstants.PUSHTODEVICE + action;

    return this.httpMethod.patch(url, comment)
      .pipe(map((res: any) =>
        res));
  }


  getApprovedPartners(approved){
    let url = OemConstants.SKU_COMMON + OemConstants.SLASH_CONTENTS + OemConstants.SLASH + OemConstants.STATUS + OemConstants.SLASH + approved;
    return this.httpMethod.get(url)
      .pipe(map((res: any) =>
        res));
  }

  publishMessageToOEM(publishJson: string) {
    const url = PartnersConstants.PARTNER + PartnersConstants.PARTNER + PartnersConstants.PUBLISH_MESSAGE;

    return this.httpMethod.post(url, publishJson)
      .pipe(map((res: any) =>
        res));
  }
  getPreviousOEMMessage() {
    const url = this.previous_message_url;
    return this.httpMethod.get(url)
      .pipe(map((res: any) =>
        res));
  }

  putImageVideoFiles(data: File, filetype: string, partnerId: string, dataType: string) {
    const url = this.newPutImageUrl + partnerId + dataType;
    return this.httpMethod.putImage(url, data, filetype, true)
      .pipe(map((res: any) =>
        res));
  }

  getOEMSystemIds(){
    let url = OemConstants.SKU_COMMON + OemConstants.SLASH + OemConstants.SYSTEMIDS;
    return this.httpMethod.get(url)
      .pipe(map((res: any) =>
        res));
  }
}
